import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cashsummary:[],
    realized:[],
    transaction:[],
    nonmarginportfolio:[],
    marginportfolio:[],

};

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setReportData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearReport: (state) => {
      return initialState;
    },
  },
});

export const { setReportData,clearReport } = reportSlice.actions;
export default reportSlice.reducer;

